export const useLocationService = () => {
	const notyf = useNotyfService()
	const $t = useI18n().t
	const getCityFromGoogle = async (position: any) => {
		const result = await ApiService.decodeCoordinates(position.coords.latitude, position.coords.longitude)
		if (result.status === 'OK')
			return result.results[0].address_components.find((item: any) => item.types.includes('locality'))?.long_name as string
	}

	const isCityOnList = (city: string, items?: any[]) => {
		const cityArray = items?.map((item) => item.city)
		const uniqueCityArray = [...new Set(cityArray)]
		return uniqueCityArray.includes(city)
	}

	const getUserLocation = async (items = []) => {
		try {
			let potentialPosition = null
			const position = await new Promise((resolve, reject) => {
				navigator.geolocation.getCurrentPosition(resolve, reject)
			})
			const city = await getCityFromGoogle(position)
			if (city && items && isCityOnList(city, items)) {
				potentialPosition = city
			} else {
				potentialPosition = getNearestLocation(position)
			}
			return potentialPosition
		} catch (error) {
			if ((error as Error).message === 'User denied Geolocation') notyf?.error($t('error.user_denied_geolocation'))
			else notyf?.error((error as Error).message)
		}
	}

	const getUserPreciseLocation = async () => {
		try {
			const position: any = await new Promise((resolve, reject) => {
				navigator.geolocation.getCurrentPosition(resolve, reject)
			})
			const decodedCoordinates = await ApiService.decodeCoordinates(position.coords.latitude, position.coords.longitude)
			const formattedAddress = decodedCoordinates.results[0]?.formatted_address

			return formattedAddress
		} catch (error) {
			if ((error as Error).message === 'User denied Geolocation') notyf?.error($t('error.user_denied_geolocation'))
			else notyf?.error((error as Error).message)
		}
	}

	const getNearestLocation = (position: { coords: { latitude: number; longitude: number } }) => {
		const { latitude, longitude } = position.coords
		const calculateDistance = (lat: number, lng: number) => {
			const R = 6371 // earth radius
			const dLat = ((lat - latitude) * Math.PI) / 180
			const dLon = ((lng - longitude) * Math.PI) / 180
			const a =
				Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos((latitude * Math.PI) / 180) * Math.cos((lat * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
			const distance = R * c // in km
			return distance
		}
		let nearestLocation = null
		let minDistance = Infinity
		for (const location of locations) {
			const distance = calculateDistance(location.lat, location.lng)
			if (distance < minDistance) {
				minDistance = distance
				nearestLocation = location
			}
		}
		return nearestLocation?.city
	}

	const locations = [
		{
			lat: 51.10961466981891,
			lng: 16.880501199386632,
			city: 'Wrocław',
		},
		{
			lat: 52.17925110756124,
			lng: 20.998522705741898,
			city: 'Warszawa',
		},
		{
			lat: 50.259054289826544,
			lng: 19.03553601283956,
			city: 'Katowice',
		},
		{
			lat: 50.07086936838364,
			lng: 19.95298339114422,
			city: 'Kraków',
		},
		{
			lat: 52.41519502531391,
			lng: 16.829767785807785,
			city: 'Poznań',
		},
		{
			lat: 54.46200985520823,
			lng: 18.463998992601574,
			city: 'Gdańsk',
		},
		{
			lat: 53.439311562540105,
			lng: 14.532596238938842,
			city: 'Szczecin',
		},
		{
			lat: 50.14292060930057,
			lng: 22.01784302572501,
			city: 'Rzeszów',
		},
		{
			lat: 53.13734006792588,
			lng: 23.16672445345022,
			city: 'Białystok',
		},
		{
			lat: 51.75855456660307,
			long: 19.455680706310012,
			city: 'Łódź',
		},
	]

	return { getUserLocation, getUserPreciseLocation }
}
